import request from '@/utils/request'

// 获取加好友配置列表
export function friendsList(params) {
  return request({
    url: '/spWorkWechat/spCorp/friendConfigIndex',
    method: 'get',
    params
  })
}
// 加好友配置添加
export function addFriends(data) {
  console.log('tian')
  return request({
    url: `/spWorkWechat/spCorp/friendConfigAdd`,
    method: 'post',
    data
  })
}
// 加好友配置修改
export function friendConfigUpdate(data) {
  return request({
    url: `/spWorkWechat/spCorp/friendConfigUpdate`,
    method: 'post',
    data
  })
}
// 加好友配置删除
export function friendConfigDel(data) {
  return request({
    url: `/spWorkWechat/spCorp/friendConfigDel`,
    method: 'post',
    data
  })
}
